import request from '@/utils/request';
const { VUE_APP_LAOSHIBANG } = process.env;

// 裂变活动信息配置获取
export function getInviteInfo(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/activity/info',
    method: 'post',
    data: { ...params }
  });
}

// 发起者获取裂变活动信息
export function getInviteUserOldinfo(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/activity/fission/oldinfo',
    method: 'post',
    data: { ...params }
  });
}